// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   LAYOUT
   ============================================ */

.app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.app-main {
  flex: 1 1;
  padding-bottom: 2rem;
}

/* ============================================
   TAB NAVIGATION
   ============================================ */

.tab-nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: var(--bg-secondary);
  border-bottom: 1px solid var(--border-color);
  padding: 0 1.5rem;
  position: sticky;
  top: 0;
  z-index: 100;
}

.tab-nav-brand {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 0;
}

.brand-icon {
  font-size: 1.5rem;
  color: var(--accent-gold);
}

.brand-text {
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--text-primary);
  letter-spacing: 0.02em;
}

.tab-nav-links {
  display: flex;
  gap: 0.25rem;
}

.tab-link {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.75rem 1rem;
  color: var(--text-secondary);
  font-size: 0.9rem;
  font-weight: 500;
  text-decoration: none;
  border-bottom: 2px solid transparent;
  transition: all var(--transition);
}

.tab-link:hover {
  color: var(--text-primary);
  background: rgba(255, 255, 255, 0.04);
}

.tab-link.active {
  color: var(--accent-gold);
  border-bottom-color: var(--accent-gold);
}

.tab-icon {
  font-size: 1rem;
}

/* ============================================
   PAGE HERO
   ============================================ */

.page-hero {
  text-align: center;
  padding: 3rem 1.5rem 2rem;
  background: linear-gradient(180deg, var(--bg-secondary) 0%, var(--bg-primary) 100%);
  border-bottom: 1px solid var(--border-color);
}

.page-hero h1 {
  font-size: 2rem;
  font-weight: 700;
  color: var(--accent-gold);
  margin-bottom: 0.5rem;
  line-height: 1.2;
}

.hero-subtitle {
  color: var(--text-secondary);
  font-size: 1.05rem;
  max-width: 640px;
  margin: 0 auto;
}

/* ============================================
   BHUMI WHEEL
   ============================================ */

.wheel-section {
  max-width: 900px;
  margin: 0 auto;
  padding: 2rem 1.5rem;
}

.wheel-intro {
  text-align: center;
  margin-bottom: 1.5rem;
}

.wheel-intro h2 {
  color: var(--accent-gold);
  margin-bottom: 0.5rem;
}

.wheel-intro p {
  color: var(--text-secondary);
  max-width: 540px;
  margin: 0 auto;
}

.bhumi-wheel-container {
  display: flex;
  justify-content: center;
  margin-bottom: 1.5rem;
}

.bhumi-wheel {
  width: 100%;
  max-width: 380px;
  cursor: pointer;
}

.wheel-segment path {
  transition: opacity var(--transition);
  stroke: var(--bg-primary);
  stroke-width: 2;
}

.wheel-segment:hover path {
  opacity: 1;
}

.wheel-text {
  fill: white;
  font-size: 16px;
  font-weight: 700;
  pointer-events: none;
}

.wheel-center {
  fill: var(--bg-primary);
  stroke: var(--accent-gold);
  stroke-width: 2;
}

.wheel-center-text {
  fill: var(--accent-gold);
  font-size: 16px;
  font-weight: 600;
}

/* ============================================
   BHUMI DETAIL PANEL
   ============================================ */

.bhumi-detail {
  background: var(--bg-card);
  border-radius: var(--radius-lg);
  border: 2px solid;
  overflow: hidden;
  box-shadow: var(--shadow-md);
  margin-top: 1rem;
}

.bhumi-detail-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem 1.25rem;
  color: white;
}

.bhumi-number {
  font-size: 2rem;
  font-weight: 800;
  opacity: 0.9;
  min-width: 2.5rem;
  text-align: center;
}

.bhumi-detail-header h3 {
  font-size: 1.15rem;
  font-weight: 600;
  margin: 0;
}

.bhumi-meaning {
  font-size: 0.85rem;
  opacity: 0.85;
  margin: 0.15rem 0 0;
}

.close-btn {
  margin-left: auto;
  background: rgba(255, 255, 255, 0.15);
  border: none;
  color: white;
  font-size: 1.3rem;
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.close-btn:hover {
  background: rgba(255, 255, 255, 0.3);
  border-color: transparent;
}

.bhumi-detail-body {
  padding: 1.25rem;
}

.bhumi-detail-body > p {
  color: var(--text-secondary);
  margin-bottom: 1rem;
  line-height: 1.7;
}

.bhumi-detail-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  margin-bottom: 1rem;
}

.detail-block {
  margin-bottom: 1rem;
}

.detail-block h4 {
  color: var(--accent-gold);
  font-size: 0.85rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 0.4rem;
}

.detail-block ul {
  color: var(--text-secondary);
  font-size: 0.9rem;
}

.detail-block p {
  color: var(--text-secondary);
  font-size: 0.9rem;
}

.paramita-tag {
  display: inline-block;
  padding: 0.3rem 0.75rem;
  border-radius: var(--radius-sm);
  color: white;
  font-weight: 600;
  font-size: 0.85rem;
}

.detail-refs {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
  margin-top: 0.3rem;
}

/* ============================================
   LIST CARDS
   ============================================ */

.lists-section {
  max-width: 900px;
  margin: 0 auto;
  padding: 0 1.5rem;
}

.lists-intro {
  text-align: center;
  margin-bottom: 2rem;
  padding-top: 1rem;
}

.lists-intro h2 {
  color: var(--accent-gold);
  margin-bottom: 0.5rem;
}

.lists-intro p {
  color: var(--text-secondary);
  max-width: 600px;
  margin: 0 auto;
}

.category-section {
  margin-bottom: 2rem;
}

.category-header {
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid var(--border-color);
}

.category-title {
  color: var(--accent-teal);
  font-size: 1.2rem;
  font-weight: 600;
}

.category-description {
  color: var(--text-muted);
  font-size: 0.9rem;
}

.category-lists {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.highlighted .list-card {
  box-shadow: 0 0 0 2px var(--accent-gold), var(--shadow-md);
  transition: box-shadow 0.5s ease;
}

.list-card {
  background: var(--bg-card);
  border-radius: var(--radius-md);
  border: 1px solid var(--border-color);
  overflow: hidden;
  transition: border-color var(--transition);
}

.list-card:hover {
  border-color: var(--border-light);
}

.list-card-header {
  padding: 0.85rem 1.1rem;
  cursor: pointer;
  position: relative;
}

.list-card-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.list-card-title {
  font-size: 1rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0;
}

.list-card-count {
  font-size: 0.75rem;
  color: var(--text-muted);
  background: var(--bg-primary);
  padding: 0.15rem 0.5rem;
  border-radius: var(--radius-sm);
}

.list-card-subtitle {
  font-size: 0.8rem;
  color: var(--text-muted);
  margin: 0.2rem 0 0;
  font-style: italic;
}

.expand-icon {
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
  font-size: 0.9rem;
  color: var(--text-muted);
  transition: transform var(--transition);
}

.expand-icon.expanded {
  transform: translateY(-50%) rotate(180deg);
}

.expand-icon.small {
  position: static;
  transform: none;
  font-size: 0.75rem;
  margin-left: auto;
}

.expand-icon.small.expanded {
  transform: rotate(180deg);
}

.list-card-body {
  padding: 0 1.1rem 1.1rem;
  border-top: 1px solid var(--border-color);
}

.list-card-description {
  color: var(--text-secondary);
  font-size: 0.9rem;
  line-height: 1.7;
  margin: 0.85rem 0;
}

.list-card-refs {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.4rem;
  padding-top: 0.75rem;
  border-top: 1px solid var(--border-color);
  margin-top: 0.75rem;
}

.refs-label {
  font-size: 0.75rem;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-right: 0.25rem;
}

/* ============================================
   CROSS REFERENCES
   ============================================ */

.cross-ref-tag {
  display: inline-block;
  padding: 0.15rem 0.55rem;
  background: rgba(74, 144, 164, 0.15);
  color: var(--accent-teal);
  border: 1px solid rgba(74, 144, 164, 0.3);
  border-radius: var(--radius-sm);
  font-size: 0.75rem;
  font-weight: 500;
  cursor: pointer;
  transition: all var(--transition);
  font-family: inherit;
}

.cross-ref-tag:hover {
  background: rgba(74, 144, 164, 0.25);
  border-color: var(--accent-teal);
  color: var(--text-primary);
}

.cross-ref-tag.unresolved,
.cross-ref-tag.unresolved:hover {
  background: rgba(160, 160, 175, 0.08);
  color: var(--text-secondary);
  border-color: rgba(160, 160, 175, 0.2);
  cursor: not-allowed;
  opacity: 0.55;
  font-style: italic;
}

/* ============================================
   LIST ITEMS
   ============================================ */

.list-card-items {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.list-item {
  border-radius: var(--radius-sm);
  overflow: hidden;
}

.list-item-header {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.5rem 0.6rem;
  cursor: pointer;
  border-radius: var(--radius-sm);
  transition: background var(--transition);
}

.list-item-header:hover {
  background: rgba(255, 255, 255, 0.04);
}

.item-number {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.6rem;
  height: 1.6rem;
  background: var(--bg-primary);
  color: var(--accent-gold);
  border-radius: 50%;
  font-size: 0.75rem;
  font-weight: 700;
}

.item-name {
  font-weight: 600;
  font-size: 0.9rem;
  color: var(--text-primary);
}

.item-sanskrit {
  font-size: 0.8rem;
  color: var(--accent-gold-dim);
  font-style: italic;
}

.item-group-name {
  font-weight: 600;
  font-size: 0.9rem;
  color: var(--text-primary);
}

.item-count-badge {
  background: var(--accent-teal);
  color: white;
  font-size: 0.65rem;
  font-weight: 700;
  padding: 0.1rem 0.4rem;
  border-radius: var(--radius-sm);
}

.item-badge {
  font-size: 0.7rem;
  padding: 0.1rem 0.45rem;
  border-radius: var(--radius-sm);
  font-weight: 500;
}

.item-badge.paramita {
  background: rgba(212, 160, 60, 0.15);
  color: var(--accent-gold);
  border: 1px solid rgba(212, 160, 60, 0.3);
}

.item-badge.training {
  background: rgba(91, 160, 143, 0.15);
  color: var(--accent-green);
  border: 1px solid rgba(91, 160, 143, 0.3);
}

.item-badge.category {
  background: rgba(74, 144, 164, 0.15);
  color: var(--accent-teal);
  border: 1px solid rgba(74, 144, 164, 0.3);
}

.group-members {
  padding: 0.4rem 0.6rem 0.6rem 2.5rem;
  color: var(--text-secondary);
  font-size: 0.85rem;
}

.list-item-detail {
  padding: 0.5rem 0.6rem 0.75rem 2.8rem;
  font-size: 0.88rem;
}

.item-meaning {
  color: var(--accent-gold-dim);
  font-style: italic;
  margin-bottom: 0.4rem;
}

.item-desc {
  color: var(--text-secondary);
  line-height: 1.7;
  margin-bottom: 0.5rem;
}

.detail-section {
  margin-bottom: 0.6rem;
  color: var(--text-secondary);
  font-size: 0.85rem;
}

.detail-section strong {
  color: var(--text-primary);
  font-size: 0.8rem;
}

.detail-section ul {
  margin-top: 0.25rem;
}

.detail-section.enemies {
  display: flex;
  gap: 1.5rem;
  flex-wrap: wrap;
}

.detail-section.aspiration {
  color: var(--accent-gold-dim);
  font-size: 0.9rem;
  padding: 0.4rem 0;
}

.subtypes-list li {
  margin-bottom: 0.4rem;
}

/* ============================================
   GAME PAGE
   ============================================ */

.game-page {
  max-width: 700px;
  margin: 0 auto;
  padding: 0 1.5rem;
}

.game-menu {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
  margin: 2rem 0;
}

.game-mode-card {
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-md);
  padding: 1.25rem;
  cursor: pointer;
  transition: all var(--transition);
  position: relative;
}

.game-mode-card:hover {
  border-color: var(--accent-gold);
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.game-mode-card h3 {
  color: var(--accent-gold);
  margin-bottom: 0.4rem;
  font-size: 1.05rem;
}

.game-mode-card p {
  color: var(--text-secondary);
  font-size: 0.85rem;
}

.game-mode-badge {
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
  background: var(--accent-teal);
  color: white;
  font-size: 0.7rem;
  font-weight: 700;
  padding: 0.15rem 0.5rem;
  border-radius: var(--radius-sm);
}

.game-info {
  margin-top: 1rem;
}

.game-info h3 {
  color: var(--text-primary);
  font-size: 0.95rem;
  margin-bottom: 0.75rem;
}

.category-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
}

.cat-tag {
  padding: 0.2rem 0.6rem;
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-sm);
  font-size: 0.78rem;
  color: var(--text-secondary);
  font-family: inherit;
  cursor: pointer;
  transition: all var(--transition);
}

button.cat-tag:hover {
  background: rgba(74, 144, 164, 0.18);
  border-color: var(--accent-teal);
  color: var(--text-primary);
}

.cat-tag.unresolved,
.cat-tag.unresolved:hover {
  background: rgba(160, 160, 175, 0.08);
  border-color: rgba(160, 160, 175, 0.2);
  color: var(--text-secondary);
  cursor: not-allowed;
  opacity: 0.55;
  font-style: italic;
}

/* Quiz */

.quiz-container {
  margin-top: 2rem;
}

.quiz-progress {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1.5rem;
}

.quiz-progress-bar {
  flex: 1 1;
  height: 6px;
  background: var(--bg-card);
  border-radius: 3px;
  overflow: hidden;
}

.quiz-progress-fill {
  height: 100%;
  background: var(--accent-gold);
  transition: width 0.3s ease;
  border-radius: 3px;
}

.quiz-progress-text,
.quiz-score-text {
  font-size: 0.8rem;
  color: var(--text-muted);
  white-space: nowrap;
}

.quiz-category-badge {
  display: inline-block;
  padding: 0.2rem 0.65rem;
  background: rgba(74, 144, 164, 0.15);
  color: var(--accent-teal);
  border-radius: var(--radius-sm);
  font-size: 0.78rem;
  font-weight: 600;
  margin-bottom: 0.75rem;
}

.quiz-question {
  font-size: 1.15rem;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 1.25rem;
  line-height: 1.5;
}

.quiz-options {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.quiz-option {
  display: block;
  width: 100%;
  padding: 0.85rem 1rem;
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-md);
  color: var(--text-primary);
  font-size: 0.95rem;
  text-align: left;
  cursor: pointer;
  transition: all var(--transition);
  font-family: inherit;
}

.quiz-option:hover:not(.correct):not(.wrong) {
  border-color: var(--accent-teal);
  background: var(--bg-card-hover);
}

.quiz-option.correct {
  border-color: var(--accent-green);
  background: rgba(91, 160, 143, 0.15);
  color: var(--accent-green);
}

.quiz-option.wrong {
  border-color: var(--accent-rose);
  background: rgba(201, 94, 94, 0.15);
  color: var(--accent-rose);
}

.quiz-feedback {
  margin-top: 1rem;
  text-align: center;
}

.feedback-correct {
  color: var(--accent-green);
  font-weight: 600;
  font-size: 1.1rem;
}

.feedback-wrong {
  color: var(--accent-rose);
  font-size: 0.95rem;
}

.feedback-wrong strong {
  color: var(--accent-green);
}

.next-btn {
  margin-top: 0.75rem;
  padding: 0.6rem 2rem;
  background: var(--accent-gold);
  color: var(--bg-primary);
  border: none;
  border-radius: var(--radius-md);
  font-weight: 600;
  font-size: 0.95rem;
  cursor: pointer;
  font-family: inherit;
}

.next-btn:hover {
  background: var(--accent-gold-dim);
  border-color: transparent;
}

/* Quiz Result */

.quiz-result {
  text-align: center;
  padding: 3rem 0;
}

.quiz-result h2 {
  color: var(--accent-gold);
  margin-bottom: 1.5rem;
}

.score-circle {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 140px;
  height: 140px;
  border-radius: 50%;
  background: var(--bg-card);
  border: 3px solid var(--accent-gold);
  margin: 0 auto 1.5rem;
}

.score-pct {
  font-size: 2.2rem;
  font-weight: 800;
  color: var(--accent-gold);
}

.score-frac {
  font-size: 0.85rem;
  color: var(--text-muted);
}

.score-message {
  color: var(--text-secondary);
  font-size: 1.05rem;
  margin-bottom: 1.5rem;
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
}

.quiz-actions {
  display: flex;
  gap: 0.75rem;
  justify-content: center;
}

.quiz-actions button {
  padding: 0.6rem 1.5rem;
  border-radius: var(--radius-md);
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  font-family: inherit;
}

.quiz-actions button:first-child {
  background: var(--accent-gold);
  color: var(--bg-primary);
  border: none;
}

.quiz-actions button:last-child {
  background: var(--bg-card);
  color: var(--text-primary);
  border: 1px solid var(--border-color);
}

/* ============================================
   REFERENCES PAGE
   ============================================ */

.references-page {
  max-width: 800px;
  margin: 0 auto;
  padding: 0 1.5rem;
}

.references-section {
  margin: 2rem 0;
}

.references-section h2 {
  color: var(--accent-gold);
  font-size: 1.25rem;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid var(--border-color);
}

/* FAQ */

.faq-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.faq-item {
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-md);
  overflow: hidden;
}

.faq-question {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0.85rem 1rem;
  background: none;
  border: none;
  color: var(--text-primary);
  font-size: 0.95rem;
  font-weight: 600;
  text-align: left;
  cursor: pointer;
  font-family: inherit;
}

.faq-question:hover {
  background: rgba(255, 255, 255, 0.03);
  border-color: transparent;
}

.faq-question.open {
  border-bottom: 1px solid var(--border-color);
}

.faq-toggle {
  font-size: 1.2rem;
  color: var(--accent-gold);
  min-width: 1.5rem;
  text-align: center;
}

.faq-answer {
  padding: 0.85rem 1rem;
  color: var(--text-secondary);
  font-size: 0.9rem;
  line-height: 1.7;
}

/* Glossary */

.glossary-search {
  width: 100%;
  padding: 0.65rem 1rem;
  background: var(--bg-input);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-md);
  color: var(--text-primary);
  font-size: 0.9rem;
  margin-bottom: 1rem;
  font-family: inherit;
}

.glossary-search::placeholder {
  color: var(--text-muted);
}

.glossary-search:focus {
  outline: none;
  border-color: var(--accent-teal);
}

.glossary-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 0.5rem;
}

.glossary-item {
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-sm);
  padding: 0.65rem 0.85rem;
}

.glossary-item dt {
  color: var(--accent-gold);
  font-weight: 700;
  font-size: 0.9rem;
  margin-bottom: 0.2rem;
}

.glossary-item dd {
  color: var(--text-secondary);
  font-size: 0.82rem;
  margin: 0;
}

/* Study Paths */

.study-paths {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 1rem;
}

.study-path-card {
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-md);
  padding: 1.1rem;
}

.study-path-card h3 {
  color: var(--accent-teal);
  font-size: 1rem;
  margin-bottom: 0.6rem;
}

.study-path-card ol {
  color: var(--text-secondary);
  font-size: 0.85rem;
}

/* ============================================
   ABOUT PAGE
   ============================================ */

.about-page {
  max-width: 800px;
  margin: 0 auto;
  padding: 0 1.5rem;
}

.about-section {
  margin: 2rem 0;
}

.about-section h2 {
  color: var(--accent-gold);
  font-size: 1.25rem;
  margin-bottom: 0.75rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid var(--border-color);
}

.about-section > p {
  color: var(--text-secondary);
  line-height: 1.7;
  margin-bottom: 0.75rem;
}

.about-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 1rem;
}

.about-card {
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-md);
  padding: 1.1rem;
}

.about-card h3 {
  color: var(--accent-teal);
  font-size: 0.95rem;
  margin-bottom: 0.4rem;
}

.about-card p {
  color: var(--text-secondary);
  font-size: 0.85rem;
}

.sources-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.source-item {
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-md);
  padding: 1rem;
}

.source-item h3 {
  color: var(--accent-gold-dim);
  font-size: 0.95rem;
  font-style: italic;
  margin-bottom: 0.3rem;
}

.source-item p {
  color: var(--text-secondary);
  font-size: 0.85rem;
}

.coverage-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
  margin-top: 0.5rem;
}

.coverage-item {
  display: inline-block;
  padding: 0.25rem 0.65rem;
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-sm);
  color: var(--text-secondary);
  font-size: 0.8rem;
}

.coverage-item--link {
  cursor: pointer;
  font-family: inherit;
  transition: background 0.2s, color 0.2s, border-color 0.2s;
}

.coverage-item--link:hover,
.coverage-item--link:focus-visible {
  background: var(--accent-color, #b8860b);
  color: #fff;
  border-color: var(--accent-color, #b8860b);
  outline: none;
}

.future-list {
  color: var(--text-secondary);
  font-size: 0.9rem;
}

.future-list li {
  margin-bottom: 0.5rem;
}

/* ============================================
   GAME TYPE MENU
   ============================================ */

.game-type-section {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
  margin: 2rem 0;
}

.game-type-card {
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-md);
  padding: 1.25rem;
  cursor: pointer;
  transition: all var(--transition);
  position: relative;
  text-align: center;
}

.game-type-card:hover {
  border-color: var(--accent-gold);
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.game-type-icon {
  font-size: 2rem;
  margin-bottom: 0.5rem;
  opacity: 0.8;
}

.game-type-card h3 {
  color: var(--accent-gold);
  margin-bottom: 0.4rem;
  font-size: 1.05rem;
}

.game-type-card p {
  color: var(--text-secondary);
  font-size: 0.82rem;
  line-height: 1.5;
}

.back-to-menu-btn {
  display: block;
  margin: 1.5rem auto 0;
  padding: 0.5rem 1.5rem;
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-md);
  color: var(--text-secondary);
  font-size: 0.85rem;
  cursor: pointer;
  font-family: inherit;
  transition: all var(--transition);
}

.back-to-menu-btn:hover {
  border-color: var(--accent-teal);
  color: var(--text-primary);
}

.back-to-menu-btn.small {
  margin: 0;
  padding: 0.35rem 0.85rem;
  font-size: 0.8rem;
}

/* ============================================
   MATCHING PAIRS
   ============================================ */

.matching-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin: 1.5rem 0 1rem;
  flex-wrap: wrap;
}

.matching-stats {
  display: flex;
  gap: 1rem;
  color: var(--text-secondary);
  font-size: 0.85rem;
}

.matching-stats span {
  background: var(--bg-card);
  padding: 0.25rem 0.65rem;
  border-radius: var(--radius-sm);
  border: 1px solid var(--border-color);
}

.matching-grid {
  display: grid;
  gap: 0.5rem;
  margin: 1rem 0;
}

.matching-card {
  aspect-ratio: 1;
  border: 1px solid var(--border-color);
  border-radius: var(--radius-md);
  background: var(--bg-card);
  cursor: pointer;
  font-family: inherit;
  font-size: 0.8rem;
  color: var(--text-primary);
  transition: all 0.3s ease;
  perspective: 600px;
  padding: 0;
  overflow: hidden;
}

.matching-card:hover:not(.matched) {
  border-color: var(--accent-teal);
  box-shadow: var(--shadow-md);
}

.matching-card-inner {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  position: relative;
}

.matching-card-front,
.matching-card-back {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 0.4rem;
  text-align: center;
  word-break: break-word;
  line-height: 1.3;
}

.matching-card-front {
  font-size: 1.5rem;
  opacity: 0.4;
}

.matching-card-back {
  display: none;
  font-weight: 600;
  font-size: 0.78rem;
}

.matching-card.flipped .matching-card-front,
.matching-card.matched .matching-card-front {
  display: none;
}

.matching-card.flipped .matching-card-back,
.matching-card.matched .matching-card-back {
  display: flex;
}

.matching-card.flipped {
  border-color: var(--accent-gold);
  background: rgba(212, 160, 60, 0.1);
}

.matching-card.matched {
  border-color: var(--accent-green);
  background: rgba(91, 160, 143, 0.12);
  opacity: 0.85;
  cursor: default;
}

.matching-card.matched .matching-card-back {
  color: var(--accent-green);
}

/* ============================================
   SEQUENCING
   ============================================ */

.sequence-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin: 1.5rem 0 0.5rem;
  flex-wrap: wrap;
}

.sequence-title {
  color: var(--accent-gold);
  font-size: 1.1rem;
  margin: 0;
  flex: 1 1;
}

.sequence-attempts {
  font-size: 0.85rem;
  color: var(--text-muted);
  background: var(--bg-card);
  padding: 0.25rem 0.65rem;
  border-radius: var(--radius-sm);
  border: 1px solid var(--border-color);
}

.sequence-instructions {
  color: var(--text-secondary);
  font-size: 0.9rem;
  margin: 0.5rem 0 1rem;
}

.sequence-list {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  margin-bottom: 1.5rem;
}

.sequence-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.7rem 1rem;
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-md);
  cursor: pointer;
  font-family: inherit;
  font-size: 0.9rem;
  color: var(--text-primary);
  text-align: left;
  transition: all var(--transition);
  width: 100%;
}

.sequence-item:hover:not(.correct):not(.wrong) {
  border-color: var(--accent-teal);
  background: var(--bg-card-hover);
}

.sequence-item.selected {
  border-color: var(--accent-gold);
  background: rgba(212, 160, 60, 0.1);
  box-shadow: 0 0 0 1px var(--accent-gold);
}

.sequence-item.correct {
  border-color: var(--accent-green);
  background: rgba(91, 160, 143, 0.12);
}

.sequence-item.wrong {
  border-color: var(--accent-rose);
  background: rgba(201, 94, 94, 0.1);
}

.sequence-slot {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.8rem;
  height: 1.8rem;
  background: var(--bg-primary);
  color: var(--accent-gold);
  border-radius: 50%;
  font-size: 0.8rem;
  font-weight: 700;
  flex-shrink: 0;
}

.sequence-label {
  flex: 1 1;
  font-weight: 500;
}

.sequence-correct-pos {
  font-size: 0.75rem;
  color: var(--accent-rose);
  opacity: 0.8;
  white-space: nowrap;
}

.sequence-actions {
  text-align: center;
  margin-bottom: 2rem;
}

/* ============================================
   RESPONSIVE
   ============================================ */

@media (max-width: 640px) {
  .tab-nav {
    flex-direction: column;
    padding: 0.5rem;
    gap: 0;
  }

  .tab-nav-links {
    width: 100%;
    justify-content: space-around;
  }

  .tab-link {
    flex-direction: column;
    gap: 0.15rem;
    padding: 0.5rem;
    font-size: 0.75rem;
  }

  .page-hero {
    padding: 2rem 1rem 1.5rem;
  }

  .page-hero h1 {
    font-size: 1.5rem;
  }

  .bhumi-detail-grid {
    grid-template-columns: 1fr;
  }

  .list-item-detail {
    padding-left: 0.6rem;
  }

  .detail-section.enemies {
    flex-direction: column;
    gap: 0.4rem;
  }

  .game-page {
    max-width: 100%;
    padding: 0 1rem;
  }

  .game-type-section {
    grid-template-columns: 1fr;
  }

  .matching-grid {
    grid-template-columns: repeat(3, 1fr) !important;
    gap: 0.35rem;
  }

  .matching-card {
    font-size: 0.7rem;
  }

  .matching-card-back {
    font-size: 0.68rem;
  }

  .matching-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }

  .matching-stats {
    flex-wrap: wrap;
    gap: 0.5rem;
    font-size: 0.78rem;
  }

  .sequence-item {
    padding: 0.6rem 0.75rem;
    font-size: 0.82rem;
    gap: 0.5rem;
  }

  .sequence-slot {
    min-width: 1.5rem;
    height: 1.5rem;
    font-size: 0.7rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,oBAAoB;AACtB;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,+BAA+B;EAC/B,4CAA4C;EAC5C,iBAAiB;EACjB,gBAAgB;EAChB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA;EACE,eAAe;AACjB;;AAEA;;iDAEiD;;AAEjD;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mFAAmF;EACnF,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;iDAEiD;;AAEjD;EACE,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;iDAEiD;;AAEjD;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,+BAA+B;EAC/B,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;;iDAEiD;;AAEjD;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,0DAA0D;EAC1D,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,qCAAqC;EACrC,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,6BAA6B;EAC7B,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,iBAAiB;EACjB,wBAAwB;EACxB,uCAAuC;AACzC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,yCAAyC;AAC3C;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;;iDAEiD;;AAEjD;EACE,qBAAqB;EACrB,wBAAwB;EACxB,oCAAoC;EACpC,yBAAyB;EACzB,yCAAyC;EACzC,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;;EAEE,qCAAqC;EACrC,4BAA4B;EAC5B,sCAAsC;EACtC,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,+BAA+B;EAC/B,wCAAwC;AAC1C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,6BAA6B;EAC7B,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;EACpC,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;iDAEiD;;AAEjD;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,qCAAqC;EACrC,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,8BAA8B;EAC9B,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,qCAAqC;EACrC,+BAA+B;EAC/B,kBAAkB;EAClB,4BAA4B;EAC5B,oBAAoB;EACpB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;;EAEE,qCAAqC;EACrC,sCAAsC;EACtC,4BAA4B;EAC5B,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA,SAAS;;AAET;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;;EAEE,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,oCAAoC;EACpC,yBAAyB;EACzB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;EACX,qBAAqB;EACrB,0BAA0B;EAC1B,qCAAqC;EACrC,+BAA+B;EAC/B,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;EACjC,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;EAChC,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,8BAA8B;EAC9B,wBAAwB;EACxB,YAAY;EACZ,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA,gBAAgB;;AAEhB;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,0BAA0B;EAC1B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,+BAA+B;EAC/B,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA;;iDAEiD;;AAEjD;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA,QAAQ;;AAER;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,qCAAqC;EACrC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,aAAa;;AAEb;EACE,WAAW;EACX,qBAAqB;EACrB,2BAA2B;EAC3B,qCAAqC;EACrC,+BAA+B;EAC/B,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,qCAAqC;EACrC,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,SAAS;AACX;;AAEA,gBAAgB;;AAEhB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;;iDAEiD;;AAEjD;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,qCAAqC;EACrC,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,0BAA0B;EAC1B,qCAAqC;EACrC,+BAA+B;EAC/B,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,0DAA0D;AAC5D;;AAEA;;EAEE,wCAAwC;EACxC,WAAW;EACX,0CAA0C;EAC1C,aAAa;AACf;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,qCAAqC;EACrC,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,sBAAsB;EACtB,0BAA0B;EAC1B,qCAAqC;EACrC,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,wBAAwB;EACxB,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,qCAAqC;EACrC,+BAA+B;EAC/B,0BAA0B;EAC1B,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,0BAA0B;EAC1B,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE,iCAAiC;EACjC,oCAAoC;EACpC,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,SAAS;EACT,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,0BAA0B;EAC1B,wBAAwB;EACxB,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,0BAA0B;EAC1B,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,0BAA0B;EAC1B,gBAAgB;EAChB,iCAAiC;EACjC,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,mCAAmC;EACnC,wCAAwC;AAC1C;;AAEA;EACE,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,6BAA6B;EAC7B,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;iDAEiD;;AAEjD;EACE;IACE,sBAAsB;IACtB,eAAe;IACf,MAAM;EACR;;EAEA;IACE,WAAW;IACX,6BAA6B;EAC/B;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gDAAgD;IAChD,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,eAAe;IACf,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,iBAAiB;EACnB;AACF","sourcesContent":["/* ============================================\n   LAYOUT\n   ============================================ */\n\n.app {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n}\n\n.app-main {\n  flex: 1;\n  padding-bottom: 2rem;\n}\n\n/* ============================================\n   TAB NAVIGATION\n   ============================================ */\n\n.tab-nav {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background: var(--bg-secondary);\n  border-bottom: 1px solid var(--border-color);\n  padding: 0 1.5rem;\n  position: sticky;\n  top: 0;\n  z-index: 100;\n}\n\n.tab-nav-brand {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.75rem 0;\n}\n\n.brand-icon {\n  font-size: 1.5rem;\n  color: var(--accent-gold);\n}\n\n.brand-text {\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  letter-spacing: 0.02em;\n}\n\n.tab-nav-links {\n  display: flex;\n  gap: 0.25rem;\n}\n\n.tab-link {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  padding: 0.75rem 1rem;\n  color: var(--text-secondary);\n  font-size: 0.9rem;\n  font-weight: 500;\n  text-decoration: none;\n  border-bottom: 2px solid transparent;\n  transition: all var(--transition);\n}\n\n.tab-link:hover {\n  color: var(--text-primary);\n  background: rgba(255, 255, 255, 0.04);\n}\n\n.tab-link.active {\n  color: var(--accent-gold);\n  border-bottom-color: var(--accent-gold);\n}\n\n.tab-icon {\n  font-size: 1rem;\n}\n\n/* ============================================\n   PAGE HERO\n   ============================================ */\n\n.page-hero {\n  text-align: center;\n  padding: 3rem 1.5rem 2rem;\n  background: linear-gradient(180deg, var(--bg-secondary) 0%, var(--bg-primary) 100%);\n  border-bottom: 1px solid var(--border-color);\n}\n\n.page-hero h1 {\n  font-size: 2rem;\n  font-weight: 700;\n  color: var(--accent-gold);\n  margin-bottom: 0.5rem;\n  line-height: 1.2;\n}\n\n.hero-subtitle {\n  color: var(--text-secondary);\n  font-size: 1.05rem;\n  max-width: 640px;\n  margin: 0 auto;\n}\n\n/* ============================================\n   BHUMI WHEEL\n   ============================================ */\n\n.wheel-section {\n  max-width: 900px;\n  margin: 0 auto;\n  padding: 2rem 1.5rem;\n}\n\n.wheel-intro {\n  text-align: center;\n  margin-bottom: 1.5rem;\n}\n\n.wheel-intro h2 {\n  color: var(--accent-gold);\n  margin-bottom: 0.5rem;\n}\n\n.wheel-intro p {\n  color: var(--text-secondary);\n  max-width: 540px;\n  margin: 0 auto;\n}\n\n.bhumi-wheel-container {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 1.5rem;\n}\n\n.bhumi-wheel {\n  width: 100%;\n  max-width: 380px;\n  cursor: pointer;\n}\n\n.wheel-segment path {\n  transition: opacity var(--transition);\n  stroke: var(--bg-primary);\n  stroke-width: 2;\n}\n\n.wheel-segment:hover path {\n  opacity: 1;\n}\n\n.wheel-text {\n  fill: white;\n  font-size: 16px;\n  font-weight: 700;\n  pointer-events: none;\n}\n\n.wheel-center {\n  fill: var(--bg-primary);\n  stroke: var(--accent-gold);\n  stroke-width: 2;\n}\n\n.wheel-center-text {\n  fill: var(--accent-gold);\n  font-size: 16px;\n  font-weight: 600;\n}\n\n/* ============================================\n   BHUMI DETAIL PANEL\n   ============================================ */\n\n.bhumi-detail {\n  background: var(--bg-card);\n  border-radius: var(--radius-lg);\n  border: 2px solid;\n  overflow: hidden;\n  box-shadow: var(--shadow-md);\n  margin-top: 1rem;\n}\n\n.bhumi-detail-header {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 1rem 1.25rem;\n  color: white;\n}\n\n.bhumi-number {\n  font-size: 2rem;\n  font-weight: 800;\n  opacity: 0.9;\n  min-width: 2.5rem;\n  text-align: center;\n}\n\n.bhumi-detail-header h3 {\n  font-size: 1.15rem;\n  font-weight: 600;\n  margin: 0;\n}\n\n.bhumi-meaning {\n  font-size: 0.85rem;\n  opacity: 0.85;\n  margin: 0.15rem 0 0;\n}\n\n.close-btn {\n  margin-left: auto;\n  background: rgba(255, 255, 255, 0.15);\n  border: none;\n  color: white;\n  font-size: 1.3rem;\n  width: 2rem;\n  height: 2rem;\n  border-radius: 50%;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n}\n\n.close-btn:hover {\n  background: rgba(255, 255, 255, 0.3);\n  border-color: transparent;\n}\n\n.bhumi-detail-body {\n  padding: 1.25rem;\n}\n\n.bhumi-detail-body > p {\n  color: var(--text-secondary);\n  margin-bottom: 1rem;\n  line-height: 1.7;\n}\n\n.bhumi-detail-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.detail-block {\n  margin-bottom: 1rem;\n}\n\n.detail-block h4 {\n  color: var(--accent-gold);\n  font-size: 0.85rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  margin-bottom: 0.4rem;\n}\n\n.detail-block ul {\n  color: var(--text-secondary);\n  font-size: 0.9rem;\n}\n\n.detail-block p {\n  color: var(--text-secondary);\n  font-size: 0.9rem;\n}\n\n.paramita-tag {\n  display: inline-block;\n  padding: 0.3rem 0.75rem;\n  border-radius: var(--radius-sm);\n  color: white;\n  font-weight: 600;\n  font-size: 0.85rem;\n}\n\n.detail-refs {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n  margin-top: 0.3rem;\n}\n\n/* ============================================\n   LIST CARDS\n   ============================================ */\n\n.lists-section {\n  max-width: 900px;\n  margin: 0 auto;\n  padding: 0 1.5rem;\n}\n\n.lists-intro {\n  text-align: center;\n  margin-bottom: 2rem;\n  padding-top: 1rem;\n}\n\n.lists-intro h2 {\n  color: var(--accent-gold);\n  margin-bottom: 0.5rem;\n}\n\n.lists-intro p {\n  color: var(--text-secondary);\n  max-width: 600px;\n  margin: 0 auto;\n}\n\n.category-section {\n  margin-bottom: 2rem;\n}\n\n.category-header {\n  margin-bottom: 1rem;\n  padding-bottom: 0.5rem;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.category-title {\n  color: var(--accent-teal);\n  font-size: 1.2rem;\n  font-weight: 600;\n}\n\n.category-description {\n  color: var(--text-muted);\n  font-size: 0.9rem;\n}\n\n.category-lists {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.highlighted .list-card {\n  box-shadow: 0 0 0 2px var(--accent-gold), var(--shadow-md);\n  transition: box-shadow 0.5s ease;\n}\n\n.list-card {\n  background: var(--bg-card);\n  border-radius: var(--radius-md);\n  border: 1px solid var(--border-color);\n  overflow: hidden;\n  transition: border-color var(--transition);\n}\n\n.list-card:hover {\n  border-color: var(--border-light);\n}\n\n.list-card-header {\n  padding: 0.85rem 1.1rem;\n  cursor: pointer;\n  position: relative;\n}\n\n.list-card-title-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.list-card-title {\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 0;\n}\n\n.list-card-count {\n  font-size: 0.75rem;\n  color: var(--text-muted);\n  background: var(--bg-primary);\n  padding: 0.15rem 0.5rem;\n  border-radius: var(--radius-sm);\n}\n\n.list-card-subtitle {\n  font-size: 0.8rem;\n  color: var(--text-muted);\n  margin: 0.2rem 0 0;\n  font-style: italic;\n}\n\n.expand-icon {\n  position: absolute;\n  right: 1rem;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 0.9rem;\n  color: var(--text-muted);\n  transition: transform var(--transition);\n}\n\n.expand-icon.expanded {\n  transform: translateY(-50%) rotate(180deg);\n}\n\n.expand-icon.small {\n  position: static;\n  transform: none;\n  font-size: 0.75rem;\n  margin-left: auto;\n}\n\n.expand-icon.small.expanded {\n  transform: rotate(180deg);\n}\n\n.list-card-body {\n  padding: 0 1.1rem 1.1rem;\n  border-top: 1px solid var(--border-color);\n}\n\n.list-card-description {\n  color: var(--text-secondary);\n  font-size: 0.9rem;\n  line-height: 1.7;\n  margin: 0.85rem 0;\n}\n\n.list-card-refs {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.4rem;\n  padding-top: 0.75rem;\n  border-top: 1px solid var(--border-color);\n  margin-top: 0.75rem;\n}\n\n.refs-label {\n  font-size: 0.75rem;\n  color: var(--text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  margin-right: 0.25rem;\n}\n\n/* ============================================\n   CROSS REFERENCES\n   ============================================ */\n\n.cross-ref-tag {\n  display: inline-block;\n  padding: 0.15rem 0.55rem;\n  background: rgba(74, 144, 164, 0.15);\n  color: var(--accent-teal);\n  border: 1px solid rgba(74, 144, 164, 0.3);\n  border-radius: var(--radius-sm);\n  font-size: 0.75rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all var(--transition);\n  font-family: inherit;\n}\n\n.cross-ref-tag:hover {\n  background: rgba(74, 144, 164, 0.25);\n  border-color: var(--accent-teal);\n  color: var(--text-primary);\n}\n\n.cross-ref-tag.unresolved,\n.cross-ref-tag.unresolved:hover {\n  background: rgba(160, 160, 175, 0.08);\n  color: var(--text-secondary);\n  border-color: rgba(160, 160, 175, 0.2);\n  cursor: not-allowed;\n  opacity: 0.55;\n  font-style: italic;\n}\n\n/* ============================================\n   LIST ITEMS\n   ============================================ */\n\n.list-card-items {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.list-item {\n  border-radius: var(--radius-sm);\n  overflow: hidden;\n}\n\n.list-item-header {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  padding: 0.5rem 0.6rem;\n  cursor: pointer;\n  border-radius: var(--radius-sm);\n  transition: background var(--transition);\n}\n\n.list-item-header:hover {\n  background: rgba(255, 255, 255, 0.04);\n}\n\n.item-number {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 1.6rem;\n  height: 1.6rem;\n  background: var(--bg-primary);\n  color: var(--accent-gold);\n  border-radius: 50%;\n  font-size: 0.75rem;\n  font-weight: 700;\n}\n\n.item-name {\n  font-weight: 600;\n  font-size: 0.9rem;\n  color: var(--text-primary);\n}\n\n.item-sanskrit {\n  font-size: 0.8rem;\n  color: var(--accent-gold-dim);\n  font-style: italic;\n}\n\n.item-group-name {\n  font-weight: 600;\n  font-size: 0.9rem;\n  color: var(--text-primary);\n}\n\n.item-count-badge {\n  background: var(--accent-teal);\n  color: white;\n  font-size: 0.65rem;\n  font-weight: 700;\n  padding: 0.1rem 0.4rem;\n  border-radius: var(--radius-sm);\n}\n\n.item-badge {\n  font-size: 0.7rem;\n  padding: 0.1rem 0.45rem;\n  border-radius: var(--radius-sm);\n  font-weight: 500;\n}\n\n.item-badge.paramita {\n  background: rgba(212, 160, 60, 0.15);\n  color: var(--accent-gold);\n  border: 1px solid rgba(212, 160, 60, 0.3);\n}\n\n.item-badge.training {\n  background: rgba(91, 160, 143, 0.15);\n  color: var(--accent-green);\n  border: 1px solid rgba(91, 160, 143, 0.3);\n}\n\n.item-badge.category {\n  background: rgba(74, 144, 164, 0.15);\n  color: var(--accent-teal);\n  border: 1px solid rgba(74, 144, 164, 0.3);\n}\n\n.group-members {\n  padding: 0.4rem 0.6rem 0.6rem 2.5rem;\n  color: var(--text-secondary);\n  font-size: 0.85rem;\n}\n\n.list-item-detail {\n  padding: 0.5rem 0.6rem 0.75rem 2.8rem;\n  font-size: 0.88rem;\n}\n\n.item-meaning {\n  color: var(--accent-gold-dim);\n  font-style: italic;\n  margin-bottom: 0.4rem;\n}\n\n.item-desc {\n  color: var(--text-secondary);\n  line-height: 1.7;\n  margin-bottom: 0.5rem;\n}\n\n.detail-section {\n  margin-bottom: 0.6rem;\n  color: var(--text-secondary);\n  font-size: 0.85rem;\n}\n\n.detail-section strong {\n  color: var(--text-primary);\n  font-size: 0.8rem;\n}\n\n.detail-section ul {\n  margin-top: 0.25rem;\n}\n\n.detail-section.enemies {\n  display: flex;\n  gap: 1.5rem;\n  flex-wrap: wrap;\n}\n\n.detail-section.aspiration {\n  color: var(--accent-gold-dim);\n  font-size: 0.9rem;\n  padding: 0.4rem 0;\n}\n\n.subtypes-list li {\n  margin-bottom: 0.4rem;\n}\n\n/* ============================================\n   GAME PAGE\n   ============================================ */\n\n.game-page {\n  max-width: 700px;\n  margin: 0 auto;\n  padding: 0 1.5rem;\n}\n\n.game-menu {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 1rem;\n  margin: 2rem 0;\n}\n\n.game-mode-card {\n  background: var(--bg-card);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-md);\n  padding: 1.25rem;\n  cursor: pointer;\n  transition: all var(--transition);\n  position: relative;\n}\n\n.game-mode-card:hover {\n  border-color: var(--accent-gold);\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-md);\n}\n\n.game-mode-card h3 {\n  color: var(--accent-gold);\n  margin-bottom: 0.4rem;\n  font-size: 1.05rem;\n}\n\n.game-mode-card p {\n  color: var(--text-secondary);\n  font-size: 0.85rem;\n}\n\n.game-mode-badge {\n  position: absolute;\n  top: 0.75rem;\n  right: 0.75rem;\n  background: var(--accent-teal);\n  color: white;\n  font-size: 0.7rem;\n  font-weight: 700;\n  padding: 0.15rem 0.5rem;\n  border-radius: var(--radius-sm);\n}\n\n.game-info {\n  margin-top: 1rem;\n}\n\n.game-info h3 {\n  color: var(--text-primary);\n  font-size: 0.95rem;\n  margin-bottom: 0.75rem;\n}\n\n.category-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n}\n\n.cat-tag {\n  padding: 0.2rem 0.6rem;\n  background: var(--bg-card);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-sm);\n  font-size: 0.78rem;\n  color: var(--text-secondary);\n  font-family: inherit;\n  cursor: pointer;\n  transition: all var(--transition);\n}\n\nbutton.cat-tag:hover {\n  background: rgba(74, 144, 164, 0.18);\n  border-color: var(--accent-teal);\n  color: var(--text-primary);\n}\n\n.cat-tag.unresolved,\n.cat-tag.unresolved:hover {\n  background: rgba(160, 160, 175, 0.08);\n  border-color: rgba(160, 160, 175, 0.2);\n  color: var(--text-secondary);\n  cursor: not-allowed;\n  opacity: 0.55;\n  font-style: italic;\n}\n\n/* Quiz */\n\n.quiz-container {\n  margin-top: 2rem;\n}\n\n.quiz-progress {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  margin-bottom: 1.5rem;\n}\n\n.quiz-progress-bar {\n  flex: 1;\n  height: 6px;\n  background: var(--bg-card);\n  border-radius: 3px;\n  overflow: hidden;\n}\n\n.quiz-progress-fill {\n  height: 100%;\n  background: var(--accent-gold);\n  transition: width 0.3s ease;\n  border-radius: 3px;\n}\n\n.quiz-progress-text,\n.quiz-score-text {\n  font-size: 0.8rem;\n  color: var(--text-muted);\n  white-space: nowrap;\n}\n\n.quiz-category-badge {\n  display: inline-block;\n  padding: 0.2rem 0.65rem;\n  background: rgba(74, 144, 164, 0.15);\n  color: var(--accent-teal);\n  border-radius: var(--radius-sm);\n  font-size: 0.78rem;\n  font-weight: 600;\n  margin-bottom: 0.75rem;\n}\n\n.quiz-question {\n  font-size: 1.15rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin-bottom: 1.25rem;\n  line-height: 1.5;\n}\n\n.quiz-options {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.quiz-option {\n  display: block;\n  width: 100%;\n  padding: 0.85rem 1rem;\n  background: var(--bg-card);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-md);\n  color: var(--text-primary);\n  font-size: 0.95rem;\n  text-align: left;\n  cursor: pointer;\n  transition: all var(--transition);\n  font-family: inherit;\n}\n\n.quiz-option:hover:not(.correct):not(.wrong) {\n  border-color: var(--accent-teal);\n  background: var(--bg-card-hover);\n}\n\n.quiz-option.correct {\n  border-color: var(--accent-green);\n  background: rgba(91, 160, 143, 0.15);\n  color: var(--accent-green);\n}\n\n.quiz-option.wrong {\n  border-color: var(--accent-rose);\n  background: rgba(201, 94, 94, 0.15);\n  color: var(--accent-rose);\n}\n\n.quiz-feedback {\n  margin-top: 1rem;\n  text-align: center;\n}\n\n.feedback-correct {\n  color: var(--accent-green);\n  font-weight: 600;\n  font-size: 1.1rem;\n}\n\n.feedback-wrong {\n  color: var(--accent-rose);\n  font-size: 0.95rem;\n}\n\n.feedback-wrong strong {\n  color: var(--accent-green);\n}\n\n.next-btn {\n  margin-top: 0.75rem;\n  padding: 0.6rem 2rem;\n  background: var(--accent-gold);\n  color: var(--bg-primary);\n  border: none;\n  border-radius: var(--radius-md);\n  font-weight: 600;\n  font-size: 0.95rem;\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.next-btn:hover {\n  background: var(--accent-gold-dim);\n  border-color: transparent;\n}\n\n/* Quiz Result */\n\n.quiz-result {\n  text-align: center;\n  padding: 3rem 0;\n}\n\n.quiz-result h2 {\n  color: var(--accent-gold);\n  margin-bottom: 1.5rem;\n}\n\n.score-circle {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 140px;\n  height: 140px;\n  border-radius: 50%;\n  background: var(--bg-card);\n  border: 3px solid var(--accent-gold);\n  margin: 0 auto 1.5rem;\n}\n\n.score-pct {\n  font-size: 2.2rem;\n  font-weight: 800;\n  color: var(--accent-gold);\n}\n\n.score-frac {\n  font-size: 0.85rem;\n  color: var(--text-muted);\n}\n\n.score-message {\n  color: var(--text-secondary);\n  font-size: 1.05rem;\n  margin-bottom: 1.5rem;\n  max-width: 400px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.quiz-actions {\n  display: flex;\n  gap: 0.75rem;\n  justify-content: center;\n}\n\n.quiz-actions button {\n  padding: 0.6rem 1.5rem;\n  border-radius: var(--radius-md);\n  font-weight: 600;\n  font-size: 0.9rem;\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.quiz-actions button:first-child {\n  background: var(--accent-gold);\n  color: var(--bg-primary);\n  border: none;\n}\n\n.quiz-actions button:last-child {\n  background: var(--bg-card);\n  color: var(--text-primary);\n  border: 1px solid var(--border-color);\n}\n\n/* ============================================\n   REFERENCES PAGE\n   ============================================ */\n\n.references-page {\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 0 1.5rem;\n}\n\n.references-section {\n  margin: 2rem 0;\n}\n\n.references-section h2 {\n  color: var(--accent-gold);\n  font-size: 1.25rem;\n  margin-bottom: 1rem;\n  padding-bottom: 0.5rem;\n  border-bottom: 1px solid var(--border-color);\n}\n\n/* FAQ */\n\n.faq-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.faq-item {\n  background: var(--bg-card);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-md);\n  overflow: hidden;\n}\n\n.faq-question {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  padding: 0.85rem 1rem;\n  background: none;\n  border: none;\n  color: var(--text-primary);\n  font-size: 0.95rem;\n  font-weight: 600;\n  text-align: left;\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.faq-question:hover {\n  background: rgba(255, 255, 255, 0.03);\n  border-color: transparent;\n}\n\n.faq-question.open {\n  border-bottom: 1px solid var(--border-color);\n}\n\n.faq-toggle {\n  font-size: 1.2rem;\n  color: var(--accent-gold);\n  min-width: 1.5rem;\n  text-align: center;\n}\n\n.faq-answer {\n  padding: 0.85rem 1rem;\n  color: var(--text-secondary);\n  font-size: 0.9rem;\n  line-height: 1.7;\n}\n\n/* Glossary */\n\n.glossary-search {\n  width: 100%;\n  padding: 0.65rem 1rem;\n  background: var(--bg-input);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-md);\n  color: var(--text-primary);\n  font-size: 0.9rem;\n  margin-bottom: 1rem;\n  font-family: inherit;\n}\n\n.glossary-search::placeholder {\n  color: var(--text-muted);\n}\n\n.glossary-search:focus {\n  outline: none;\n  border-color: var(--accent-teal);\n}\n\n.glossary-list {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 0.5rem;\n}\n\n.glossary-item {\n  background: var(--bg-card);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-sm);\n  padding: 0.65rem 0.85rem;\n}\n\n.glossary-item dt {\n  color: var(--accent-gold);\n  font-weight: 700;\n  font-size: 0.9rem;\n  margin-bottom: 0.2rem;\n}\n\n.glossary-item dd {\n  color: var(--text-secondary);\n  font-size: 0.82rem;\n  margin: 0;\n}\n\n/* Study Paths */\n\n.study-paths {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 1rem;\n}\n\n.study-path-card {\n  background: var(--bg-card);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-md);\n  padding: 1.1rem;\n}\n\n.study-path-card h3 {\n  color: var(--accent-teal);\n  font-size: 1rem;\n  margin-bottom: 0.6rem;\n}\n\n.study-path-card ol {\n  color: var(--text-secondary);\n  font-size: 0.85rem;\n}\n\n/* ============================================\n   ABOUT PAGE\n   ============================================ */\n\n.about-page {\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 0 1.5rem;\n}\n\n.about-section {\n  margin: 2rem 0;\n}\n\n.about-section h2 {\n  color: var(--accent-gold);\n  font-size: 1.25rem;\n  margin-bottom: 0.75rem;\n  padding-bottom: 0.5rem;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.about-section > p {\n  color: var(--text-secondary);\n  line-height: 1.7;\n  margin-bottom: 0.75rem;\n}\n\n.about-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 1rem;\n}\n\n.about-card {\n  background: var(--bg-card);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-md);\n  padding: 1.1rem;\n}\n\n.about-card h3 {\n  color: var(--accent-teal);\n  font-size: 0.95rem;\n  margin-bottom: 0.4rem;\n}\n\n.about-card p {\n  color: var(--text-secondary);\n  font-size: 0.85rem;\n}\n\n.sources-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.source-item {\n  background: var(--bg-card);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-md);\n  padding: 1rem;\n}\n\n.source-item h3 {\n  color: var(--accent-gold-dim);\n  font-size: 0.95rem;\n  font-style: italic;\n  margin-bottom: 0.3rem;\n}\n\n.source-item p {\n  color: var(--text-secondary);\n  font-size: 0.85rem;\n}\n\n.coverage-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n  margin-top: 0.5rem;\n}\n\n.coverage-item {\n  display: inline-block;\n  padding: 0.25rem 0.65rem;\n  background: var(--bg-card);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-sm);\n  color: var(--text-secondary);\n  font-size: 0.8rem;\n}\n\n.coverage-item--link {\n  cursor: pointer;\n  font-family: inherit;\n  transition: background 0.2s, color 0.2s, border-color 0.2s;\n}\n\n.coverage-item--link:hover,\n.coverage-item--link:focus-visible {\n  background: var(--accent-color, #b8860b);\n  color: #fff;\n  border-color: var(--accent-color, #b8860b);\n  outline: none;\n}\n\n.future-list {\n  color: var(--text-secondary);\n  font-size: 0.9rem;\n}\n\n.future-list li {\n  margin-bottom: 0.5rem;\n}\n\n/* ============================================\n   GAME TYPE MENU\n   ============================================ */\n\n.game-type-section {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 1rem;\n  margin: 2rem 0;\n}\n\n.game-type-card {\n  background: var(--bg-card);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-md);\n  padding: 1.25rem;\n  cursor: pointer;\n  transition: all var(--transition);\n  position: relative;\n  text-align: center;\n}\n\n.game-type-card:hover {\n  border-color: var(--accent-gold);\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-md);\n}\n\n.game-type-icon {\n  font-size: 2rem;\n  margin-bottom: 0.5rem;\n  opacity: 0.8;\n}\n\n.game-type-card h3 {\n  color: var(--accent-gold);\n  margin-bottom: 0.4rem;\n  font-size: 1.05rem;\n}\n\n.game-type-card p {\n  color: var(--text-secondary);\n  font-size: 0.82rem;\n  line-height: 1.5;\n}\n\n.back-to-menu-btn {\n  display: block;\n  margin: 1.5rem auto 0;\n  padding: 0.5rem 1.5rem;\n  background: var(--bg-card);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-md);\n  color: var(--text-secondary);\n  font-size: 0.85rem;\n  cursor: pointer;\n  font-family: inherit;\n  transition: all var(--transition);\n}\n\n.back-to-menu-btn:hover {\n  border-color: var(--accent-teal);\n  color: var(--text-primary);\n}\n\n.back-to-menu-btn.small {\n  margin: 0;\n  padding: 0.35rem 0.85rem;\n  font-size: 0.8rem;\n}\n\n/* ============================================\n   MATCHING PAIRS\n   ============================================ */\n\n.matching-header {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin: 1.5rem 0 1rem;\n  flex-wrap: wrap;\n}\n\n.matching-stats {\n  display: flex;\n  gap: 1rem;\n  color: var(--text-secondary);\n  font-size: 0.85rem;\n}\n\n.matching-stats span {\n  background: var(--bg-card);\n  padding: 0.25rem 0.65rem;\n  border-radius: var(--radius-sm);\n  border: 1px solid var(--border-color);\n}\n\n.matching-grid {\n  display: grid;\n  gap: 0.5rem;\n  margin: 1rem 0;\n}\n\n.matching-card {\n  aspect-ratio: 1;\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-md);\n  background: var(--bg-card);\n  cursor: pointer;\n  font-family: inherit;\n  font-size: 0.8rem;\n  color: var(--text-primary);\n  transition: all 0.3s ease;\n  perspective: 600px;\n  padding: 0;\n  overflow: hidden;\n}\n\n.matching-card:hover:not(.matched) {\n  border-color: var(--accent-teal);\n  box-shadow: var(--shadow-md);\n}\n\n.matching-card-inner {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  position: relative;\n}\n\n.matching-card-front,\n.matching-card-back {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  padding: 0.4rem;\n  text-align: center;\n  word-break: break-word;\n  line-height: 1.3;\n}\n\n.matching-card-front {\n  font-size: 1.5rem;\n  opacity: 0.4;\n}\n\n.matching-card-back {\n  display: none;\n  font-weight: 600;\n  font-size: 0.78rem;\n}\n\n.matching-card.flipped .matching-card-front,\n.matching-card.matched .matching-card-front {\n  display: none;\n}\n\n.matching-card.flipped .matching-card-back,\n.matching-card.matched .matching-card-back {\n  display: flex;\n}\n\n.matching-card.flipped {\n  border-color: var(--accent-gold);\n  background: rgba(212, 160, 60, 0.1);\n}\n\n.matching-card.matched {\n  border-color: var(--accent-green);\n  background: rgba(91, 160, 143, 0.12);\n  opacity: 0.85;\n  cursor: default;\n}\n\n.matching-card.matched .matching-card-back {\n  color: var(--accent-green);\n}\n\n/* ============================================\n   SEQUENCING\n   ============================================ */\n\n.sequence-header {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin: 1.5rem 0 0.5rem;\n  flex-wrap: wrap;\n}\n\n.sequence-title {\n  color: var(--accent-gold);\n  font-size: 1.1rem;\n  margin: 0;\n  flex: 1;\n}\n\n.sequence-attempts {\n  font-size: 0.85rem;\n  color: var(--text-muted);\n  background: var(--bg-card);\n  padding: 0.25rem 0.65rem;\n  border-radius: var(--radius-sm);\n  border: 1px solid var(--border-color);\n}\n\n.sequence-instructions {\n  color: var(--text-secondary);\n  font-size: 0.9rem;\n  margin: 0.5rem 0 1rem;\n}\n\n.sequence-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  margin-bottom: 1.5rem;\n}\n\n.sequence-item {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.7rem 1rem;\n  background: var(--bg-card);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-md);\n  cursor: pointer;\n  font-family: inherit;\n  font-size: 0.9rem;\n  color: var(--text-primary);\n  text-align: left;\n  transition: all var(--transition);\n  width: 100%;\n}\n\n.sequence-item:hover:not(.correct):not(.wrong) {\n  border-color: var(--accent-teal);\n  background: var(--bg-card-hover);\n}\n\n.sequence-item.selected {\n  border-color: var(--accent-gold);\n  background: rgba(212, 160, 60, 0.1);\n  box-shadow: 0 0 0 1px var(--accent-gold);\n}\n\n.sequence-item.correct {\n  border-color: var(--accent-green);\n  background: rgba(91, 160, 143, 0.12);\n}\n\n.sequence-item.wrong {\n  border-color: var(--accent-rose);\n  background: rgba(201, 94, 94, 0.1);\n}\n\n.sequence-slot {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 1.8rem;\n  height: 1.8rem;\n  background: var(--bg-primary);\n  color: var(--accent-gold);\n  border-radius: 50%;\n  font-size: 0.8rem;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.sequence-label {\n  flex: 1;\n  font-weight: 500;\n}\n\n.sequence-correct-pos {\n  font-size: 0.75rem;\n  color: var(--accent-rose);\n  opacity: 0.8;\n  white-space: nowrap;\n}\n\n.sequence-actions {\n  text-align: center;\n  margin-bottom: 2rem;\n}\n\n/* ============================================\n   RESPONSIVE\n   ============================================ */\n\n@media (max-width: 640px) {\n  .tab-nav {\n    flex-direction: column;\n    padding: 0.5rem;\n    gap: 0;\n  }\n\n  .tab-nav-links {\n    width: 100%;\n    justify-content: space-around;\n  }\n\n  .tab-link {\n    flex-direction: column;\n    gap: 0.15rem;\n    padding: 0.5rem;\n    font-size: 0.75rem;\n  }\n\n  .page-hero {\n    padding: 2rem 1rem 1.5rem;\n  }\n\n  .page-hero h1 {\n    font-size: 1.5rem;\n  }\n\n  .bhumi-detail-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .list-item-detail {\n    padding-left: 0.6rem;\n  }\n\n  .detail-section.enemies {\n    flex-direction: column;\n    gap: 0.4rem;\n  }\n\n  .game-page {\n    max-width: 100%;\n    padding: 0 1rem;\n  }\n\n  .game-type-section {\n    grid-template-columns: 1fr;\n  }\n\n  .matching-grid {\n    grid-template-columns: repeat(3, 1fr) !important;\n    gap: 0.35rem;\n  }\n\n  .matching-card {\n    font-size: 0.7rem;\n  }\n\n  .matching-card-back {\n    font-size: 0.68rem;\n  }\n\n  .matching-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.5rem;\n  }\n\n  .matching-stats {\n    flex-wrap: wrap;\n    gap: 0.5rem;\n    font-size: 0.78rem;\n  }\n\n  .sequence-item {\n    padding: 0.6rem 0.75rem;\n    font-size: 0.82rem;\n    gap: 0.5rem;\n  }\n\n  .sequence-slot {\n    min-width: 1.5rem;\n    height: 1.5rem;\n    font-size: 0.7rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
